import { IRewardData } from '../../RewardHelper';
import { RewardType } from '../../Rewards/RewardType';
import { ResourceDataSet } from '../DataSet/Resource';
import { track, TrackMethod } from '../Track';
import { report } from '../../../report';

type tRewardType = {
    [rewardType in RewardType]: {
        receivedEvent?: keyof ResourceDataSet;
        usedEvent?: keyof ResourceDataSet;
        coinsEvent?: keyof ResourceDataSet;
    };
};

const RewardTypeMap: tRewardType = {
    [RewardType.JOKER]: {
        receivedEvent: 'tJokerReceived',
        usedEvent: 'tJokerUsed',
        coinsEvent: 'tJokerCoins',
    },
    [RewardType.UNDO]: {
        receivedEvent: 'tUndoReceived',
        usedEvent: 'tUndoUsed',
        coinsEvent: 'tUndoCoins',
    },
    [RewardType.BOMB]: {
        receivedEvent: 'tMassRemoveReceived',
        usedEvent: 'tMassRemoveUsed',
        coinsEvent: 'tMassRemoveCoins',
    },
    [RewardType.SHUFFLE]: {
        receivedEvent: 'tChangerReceived',
        usedEvent: 'tChangerUsed',
        coinsEvent: 'tChangerCoins',
    },
    [RewardType.BULLSEYE]: {
        receivedEvent: 'tRemoveOneReceived',
        usedEvent: 'tRemoveOneUsed',
        coinsEvent: 'tRemoveOneCoins',
    },
    [RewardType.CARDS]: {
        receivedEvent: 'tExtraCardsReceived',
        coinsEvent: 'tExtraCardsCoins',
    },
    [RewardType.COINS]: {
        receivedEvent: 'tCoinsReceived',
        usedEvent: 'tCoinsUsed',
    },
    [RewardType.NONE]: {},
    [RewardType.OTHER]: {},
    [RewardType.PLUS_FIVE_CARDS]: {
        receivedEvent: 'tPlus5Received',
        usedEvent: 'tPlus5Used',
    },
    [RewardType.THREE_STAR_REWARD]: {},
    [RewardType.PRIZE_WHEEL_SPIN]: {},
    [RewardType.PET]: {},
    [RewardType.FREE_PLAY]: {
        receivedEvent: 'tFreeEntryReceived',
        usedEvent: 'tFreeEntryUsed',
    },
    [RewardType.PRE_BOOSTER_REMOVE_THREE]: {
        receivedEvent: 'tRemoveCardsBoostersReceived',
        usedEvent: 'tRemoveCardsBoostersUsed',
        coinsEvent: 'tRemoveCardsBoostersCoins',
    },
    [RewardType.PRE_BOOSTER_JOKER]: {
        receivedEvent: 'tExtraWildcardsBoostersReceived',
        usedEvent: 'tExtraWildcardsBoostersUsed',
        coinsEvent: 'tExtraWildcardsBoostersCoins',
    },
    [RewardType.PRE_BOOSTER_CANISTER]: {
        receivedEvent: 'tCanisterCardBoostersReceived',
        usedEvent: 'tCanisterCardBoostersUsed',
        coinsEvent: 'tCanisterCardBoostersCoins',
    },
    [RewardType.PREMIUM_SPIN]: {},
    [RewardType.FARM_AREA]: {},
    [RewardType.FARM_ITEM]: {},
    [RewardType.PLINKO_TOKEN]: {},
};

export function trackReward(reward: IRewardData) {
    try {
        if (RewardTypeMap[reward.type].receivedEvent) {
            track(RewardTypeMap[reward.type].receivedEvent, reward.value, TrackMethod.ADD);
        }
    } catch (error) {
        report('Failed to track reward', {
            error,
            once: true,
            sampleRate: 0.1,
        });
    }
}

export function resetReward(rewardType: RewardType) {
    try {
        if (RewardTypeMap[rewardType].receivedEvent) {
            track(RewardTypeMap[rewardType].receivedEvent, 0);
        }
    } catch (error) {
        report('Failed to reset reward', {
            error,
            once: true,
            sampleRate: 0.1,
        });
    }
}
